<template>
  <!-- 视频会议相关组件 -->
  <div class="text-hv">
    <p v-show="teleconferenceInfo.hostKey && reservedPermit && (statusPermit || hasCtrlPwd)">
      <span>主持人密码：</span>
      <span class="text-danger text-bold">{{teleconferenceInfo.hostKey}} <van-icon name="eye-o" @click="lookTlcInfo('hostKey')"/></span>
      <span v-show="statusPermit" class="pull-right text-primary text-sm clipboard"
           @click="tclInfoCopy('hostKey')">复制</span>
    </p>
    <p v-show="teleconferenceInfo.password">
      <span>会议密码：{{teleconferenceInfo.password}} <van-icon name="eye-o" @click="lookTlcInfo('password')"/></span>
      <span v-show="statusPermit" class="pull-right text-primary text-sm clipboard"
          @click="tclInfoCopy('password')">复制</span>
    </p>
    <p v-show="teleconferenceInfo.liveId && lvcPwd">
      <span>直播密码：{{lvcPwd}} <van-icon name="eye-o" @click="handleLvcInfo('look')"/></span>
      <span v-show="statusPermit" class="pull-right text-primary text-sm clipboard"
          @click="handleLvcInfo('copy')">复制</span>
    </p>
    <div v-show="teleconferenceInfo.joinUrl && teleconferenceInfo.manufacturer!=='xyLink'">
      <span>会议链接：</span>
      <span v-show="statusPermit" class="pull-right text-primary text-sm clipboard" @click="tclInfoCopy('joinUrl')">复制</span>
      <br/>
      <div class="pull-left van-ellipsis mar-top-5" style="width: 92%;">
        <a v-if="!isAsterisk(teleconferenceInfo.joinUrl)" class="text-underline" :href="teleconferenceInfo.joinUrl"
          target="_blank">{{teleconferenceInfo.joinUrl}}</a>
        <span v-else>{{teleconferenceInfo.joinUrl}} </span>
      </div>
      <van-icon class="mar-lft-5 pull-left mar-top-5" name="eye-o"  @click="lookTlcInfo('joinUrl')"></van-icon>
    </div>
    <van-row gutter="10" v-show="statusPermit">
      <van-col :span="joinMtHdr? '12' : '24'" class="text-center mar-top-5">
        <van-button class="clipboard text-bold" type="primary" block plain size="small"
                    @click="tclInfoCopy()">复制邀请信息
        </van-button>
      </van-col>
      <van-col span="12" class="text-center mar-top-5" v-show="joinMtHdr">
        <van-button class="text-bold" type="primary" block
                    plain size="small" @click="joinMeeting">加入会议
        </van-button>
      </van-col>
    </van-row>
    <van-divider class="mar-top-10 mar-btm-5"></van-divider>
  </div>
</template>

<script>
  import {checkIsReactNative, formatTlcInvitation, joinMtInReactNative, queryTlcInfoByKey, syncHandle} from "../../../tools/utils";
  import {tlcConfig, commonConfig} from "../../../config/common";
  import {meeting} from '../../../server';

  export default {
    props: {
      mDoc: Object,
      teleconferenceInfo: Object,
      reservedPermit: Boolean,
      statusPermit: Boolean,
    },
    data() {
      return {
        clipboard: null,
        tlcKeys: ['conferenceNum', 'password', 'joinUrl', 'hostKey', 'manufacturer'],
        lvcPwd: '',
      }
    },
    computed: {
      joinMtHdr: function () {
        return checkIsReactNative()
      },
      hasCtrlPwd() {
        return this.teleconferenceInfo.conferenceCtrlPwd
          && tlcConfig.hasCtrlPwd[this.teleconferenceInfo.manufacturer] || false;
      },
    },
    mounted() {
      this.lvcPwd = this.mDoc.liveConferenceInfo && this.mDoc.liveConferenceInfo.password || '';
    },
    methods: {
      async joinMeeting() {
        try {
          const tlcInfo = await queryTlcInfoByKey.call(this, this.tlcKeys, this.mDoc.mid);
          joinMtInReactNative(tlcInfo);
        } catch(err) {
          throw new Error(err);
        }
      },
      async tclInfoCopy(key) {
        try {
          let keys = key ? [key] : this.tlcKeys;
          const data = await queryTlcInfoByKey.call(this, keys, this.mDoc.mid);
          const text = key ? data[key] : formatTlcInvitation({...this.mDoc, teleconferenceInfo: data});
          syncHandle(() => {
            this.$copyText(text).then(() => {
              vtToast("已复制 ~")
            }, err => {
              throw new Error(err);
            })
          })
        } catch(err) {
          throw new Error(err);
        }
      },
      isAsterisk(val) {
        return commonConfig.asteriskReg.test(val);
      },
      async lookTlcInfo(key) {
        try {
          const val = this.teleconferenceInfo[key];
          if (this.isAsterisk(val) || !val) {
          const data = await queryTlcInfoByKey.call(this, [key], this.mDoc.mid);
          data[key] && (this.teleconferenceInfo[key] = data[key]);
          } else {
            this.teleconferenceInfo[key] = this.teleconferenceInfo[key].replace(/./g, '*');
          }
        } catch(err) {
          throw new Error(err);
        }
      },
      async handleLvcInfo(mode) {
        const data = {
          mid: this.mDoc.mid,
          keys: ['password']
        }
        try {
          const {searchLvcInfo: res} = await meeting.queryLvcInfo(this, {queryFilter: data});
          if (res.code === 0) {
            res.data || {}
            const {data = {}} = res;
            switch(mode) {
              case 'look':
                this.lvcPwd = commonConfig.asteriskReg.test(this.lvcPwd) ? data.password : this.mDoc.liveConferenceInfo && this.mDoc.liveConferenceInfo.password;
                break;
              case 'copy':
                if (data.password) {
                  syncHandle(() => {
                    this.$copyText(data.password).then(() => {
                      vtToast("已复制 ~");
                    }, err => {
                      throw new Error(err);
                    })
                  })
                }
                break;
            }
          }
        } catch(err) {
          throw new Error(err);
        }
      },
    }
  }
</script>

<style scoped>
</style>
